import { Text } from "ui-kit/components-branded/index"
import { CATALOG_PATH } from "modules/PsyCatalog/common/utils/catalogPath"
import { getSubRoutes } from "modules/PsyCatalog/common/utils/getSubRoutes"
import { isBrowser } from "utils/infrastructure/ssg-utils"

export function SEOText() {
    if (!isBrowser()) return null
    const { routes } = getSubRoutes(location.pathname)
    if (routes.path === CATALOG_PATH.online) {
        return SEOText.content
    }
    return null
}

SEOText.content = (
    <Text className="content">
        <p>
            В&nbsp;Alter есть психологи, которые проводят видеоконсультации. Психотерапия онлайн
            позволит вам:
        </p>
        <ul>
            <li>
                Работать с&nbsp;любым понравившимся психологом, а&nbsp;не&nbsp;только специалистами
                из&nbsp;вашего города
            </li>
            <li>Экономить время и&nbsp;средства на&nbsp;дорогу до&nbsp;кабинета</li>
            <li>Заниматься в&nbsp;комфортной домашней обстановке</li>
            <li>Продолжать психотерапию даже после переезда</li>
        </ul>
        <p>
            Здесь вы&nbsp;можете посмотреть анкеты психологов, которые работают онлайн.
            В&nbsp;каждой анкете мы&nbsp;указываем образование и&nbsp;опыт работы специалиста, его
            методы и&nbsp;принципы, которых он&nbsp;придерживается в&nbsp;работе. Выберите того, чья
            анкета &laquo;откликается&raquo;&nbsp;&mdash; все остальное мы&nbsp;уже проверили
            за&nbsp;вас!
        </p>
    </Text>
)
